export const hex2rgb = (hex: string):string => {
  let ahex = hex
  if (ahex.slice(0, 1) === "#") ahex = hex.slice(1)
  if (ahex.length === 3) ahex = ahex.split('').map((value) => (`${value}${value}`)).join('')

  return `${[ahex.slice(0, 2), ahex.slice(2, 4), ahex.slice(4, 6)].map((str) => (
    parseInt(str, 16)
  ))}`
}

// eslint-disable-next-line arrow-body-style
export const rgba2rgb = (rgb: string, alpha: number):string => {
  return `${rgb.split(/\s*(?:,|$)\s*/).map((str) => Math.floor((1 - alpha) * 255 + alpha * Number(str)))}`
}

export const rgb2hex = (rgb: string):string => `#${rgb.split(/\s*(?:,|$)\s*/).map((str) => (`0${Number(str).toString(16)}`).slice(-2)).join('')}`

export const convertHexColor = (hex: string, alpha: number):string => rgb2hex(rgba2rgb(hex2rgb(hex), alpha))

export const stringToHexSimple = (str: string):string => {
  const encoder = new TextEncoder()
  const bytes = encoder.encode(str)

  const hash = bytes.reduce((acc, curr) => acc + curr, 5381)

  const r = (hash * 13) % 256
  const g = (hash * 17) % 256
  const b = (hash * 19) % 256

  const toHex = (num: number) => num.toString(16).padStart(2, '0')

  return `#${toHex(r)}${toHex(g)}${toHex(b)}`
}
